<template>
  <div id="submitButtonWithLoader">
    <button
                :disabled="processing"
                type="submit"
                :id="id"
                class="btn btn-primary btn-block"
              >
                {{buttonText}}
                <img
                  v-if="processing"
                  class="loaderOnBtn"
                  src="@/assets/preloader.gif"
                  alt="form-processing"
                />
              </button>
  </div>
</template>

<script>
export default {
  name: 'SubmitButtonWithLoader',
  props: ["id", "buttonText",'processing'],
  data() {
    return {
      
    }
  }
};
</script>

<style>
button:disabled {
  /* background-color: #444 !important; */
  /* background-color: rgb(71, 118, 219) !important; */
  background-color: #39416d !important;
  opacity: .8 !important;
}
.loaderOnBtn {
  margin-left: 1em;
  height: 25px;
}

</style>